import React from 'react';
import styles from '../style.module.scss';
import {IPropsElement} from "../../../pages/ChecklistPage/PopupEdit/constants";

const HeaderElement: React.FC<IPropsElement> = (props) => {
    const {label, properties: {subLabel, fontSize, textAlign}} = props;
    const style = {textAlign}
    return <div className={styles.header} style={style}>
        <p data-font-size={fontSize}>{label}</p>
        <p>{subLabel}</p>
    </div>;
};

export default HeaderElement;
